/* Love N Care — header: transparent-over-hero, mega hover-intent, mobile drawer. */
(function () {
  var abort = null; // module-scoped: owns all window/document listeners so a theme-editor re-init tears the old set down

  /* Single source of truth for the transparent<->solid state: the hero emits [data-lnc-hero-overlay]
     (the CSS overlay in lnc-header.liquid keys off the same attribute). Re-checked on every call so it
     self-heals if the hero is added/switched to video after the header initialised. */
  function applySolid(header) {
    if (!document.querySelector('[data-lnc-hero-overlay]')) { header.classList.remove('is-solid'); return; }
    if (header.dataset.megaOpen) return;               // mega forces the white bar via .is-mega
    if (window.scrollY > 40) header.classList.add('is-solid');
    else header.classList.remove('is-solid');
  }

  function init(root) {
    var header = (root || document).querySelector('lnc-header');
    if (!header || header.dataset.lncReady) return;
    header.dataset.lncReady = '1';
    document.body.style.overflow = '';                 // clear any stale scroll-lock from a replaced header

    if (abort) abort.abort();                          // tear down the previous init's global listeners
    abort = new AbortController();
    var signal = abort.signal;

    /* ---------- Transparent over a full-bleed video hero (scroll -> glass) ---------- */
    var onScroll = function () { applySolid(header); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onScroll, { signal: signal });

    /* ---------- Mega menu (hover intent) ---------- */
    var closeTimer = null;
    var current = null;
    function openMega(id, trigger) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (current && current !== id) closeMega(true);
      var panel = header.querySelector('[data-mega-panel="' + id + '"]');
      if (!panel) return;
      panel.classList.add('is-open');
      if (trigger) { trigger.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      header.classList.add('is-mega');
      header.dataset.megaOpen = '1';
      current = id;
    }
    function closeMega() {
      if (!current) return;
      var panel = header.querySelector('[data-mega-panel="' + current + '"]');
      var trig = header.querySelector('[data-mega="' + current + '"] .lnc-item');
      if (panel) panel.classList.remove('is-open');
      if (trig) { trig.classList.remove('is-open'); trig.setAttribute('aria-expanded', 'false'); }
      current = null;
      delete header.dataset.megaOpen;
      header.classList.remove('is-mega');
      applySolid(header);                              // restore transparent/glass state for the current page + scroll
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeMega(); }, 180);
    }

    header.querySelectorAll('.lnc-header__navitem[data-mega]').forEach(function (item) {
      var id = item.getAttribute('data-mega');
      var trigger = item.querySelector('.lnc-item');
      item.addEventListener('mouseenter', function () { openMega(id, trigger); });
      item.addEventListener('mouseleave', scheduleClose);
      var panel = header.querySelector('[data-mega-panel="' + id + '"]');
      if (panel) {
        panel.addEventListener('mouseenter', function () { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } });
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });

    /* ---------- Mobile drawer ---------- */
    var drawer = header.querySelector('[data-lnc-drawer]');
    var burger = header.querySelector('[data-lnc-burger]');
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      drawer.querySelectorAll('[data-lnc-sub]').forEach(function (s) { s.hidden = true; });
    }
    if (drawer && burger) {
      function openDrawer() {
        drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden';
      }
      burger.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-lnc-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      drawer.querySelectorAll('[data-lnc-drill]').forEach(function (b) {
        b.addEventListener('click', function () {
          var sub = drawer.querySelector('[data-lnc-sub="' + b.getAttribute('data-lnc-drill') + '"]');
          if (sub) sub.hidden = false;
        });
      });
      drawer.querySelectorAll('[data-lnc-drill-back]').forEach(function (b) {
        b.addEventListener('click', function () { b.closest('[data-lnc-sub]').hidden = true; });
      });
      /* Accordion: opening a category closes its siblings (design: one tap deeper, never lost) */
      drawer.querySelectorAll('[data-lnc-acc]').forEach(function (acc) {
        acc.addEventListener('toggle', function () {
          if (!acc.open) return;
          drawer.querySelectorAll('[data-lnc-acc][open]').forEach(function (other) {
            if (other !== acc) other.open = false;
          });
        });
      });
    }

    /* Escape closes whichever is open (global, owned by the abort signal so re-init doesn't stack) */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeMega();
      closeDrawer();
    }, { signal: signal });
  }

  /* PDP back chevron: go back in history when the shopper came from this site,
     otherwise follow the collection href it renders with. */
  document.addEventListener('click', function (e) {
    var back = e.target.closest('[data-lnc-back]');
    if (!back) return;
    try {
      if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    } catch (err) { /* malformed referrer — follow the href */ }
  });

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    // If a *different* section changed (e.g. the hero was switched to Video), recompute the existing header's state.
    var hdr = document.querySelector('lnc-header');
    if (hdr && hdr.dataset.lncReady) applySolid(hdr);
  });
})();
